import acceptedCookiePolicy from "../../../../components/onetrust/cookiePolicy";

const wistiaConsentMode = () => {
    window._wq = window._wq || [];

    acceptedCookiePolicy({
        ifTargetingCookies: () => {
            window._wq.push(function (wistia) {
                wistia.consent(true);
            });
        },
        ifNoTargetingCookies: () => {
            window._wq.push(function (wistia) {
                wistia.consent(false);
            });
        }
    });
};

export default () => {
    let wistiaChannelVideos = '';

    wistiaConsentMode();

    document.addEventListener('click', (event) => {
        const resourceVideoID = event.target.closest('a')?.getAttribute('data-video-id');

        if(!wistiaChannelVideos) {
            wistiaChannelVideos = document.querySelectorAll('.w-video-card');
        }

        for(const video of wistiaChannelVideos) {
            const wistiaChannelVideo = document.querySelector(`[href="${video.href}"]`);

            if(wistiaChannelVideo && video.href.includes(resourceVideoID)) {
                event.preventDefault();

                wistiaChannelVideo.click();
            }
        }
    });
};